function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 404",
  d: "M48.1 124.26c30.43 0 47.6-25.16 47.6-61.88S78.53.5 48.1.5C17.84.5.5 25.66.5 62.38s17.34 61.88 47.6 61.88zm0-22.95c-15.98 0-24.14-13.77-24.14-38.93s8.16-39.1 24.14-39.1 24.31 13.94 24.31 39.1-8.33 38.93-24.31 38.93zm99.79-55.08h-12.24l1.53-21.42h45.73V2.88h-67.49l-4.76 66.13h36.04c11.56 0 18.36 6.63 18.36 16.15 0 9.69-6.8 16.15-19.04 16.15-11.9 0-18.53-5.1-21.42-14.28l-20.06 11.73c6.8 17.34 22.95 25.5 41.48 25.5 22.44 0 42.5-13.6 42.5-39.1s-18.87-38.93-40.63-38.93z",
  fill: "none",
  stroke: "#3c00dc"
});

function SvgNumber05Inline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 189.02,
    height: 124.76,
    viewBox: "0 0 189.02 124.76"
  }, props), _ref);
}

export default SvgNumber05Inline;